import React, { useState } from 'react';
import { LuChartColumn } from 'react-icons/lu';
import { Card, CardHeader } from '../ui/Card';
import { SpinnerRing } from '../ui/Spinner';

const isDarkTheme = () => document.documentElement.classList.contains('dark');

/** Plausible shared dashboard of the app, embedded. */
const PlausibleData = () => {
  const [isLoading, setIsLoading] = useState(true);
  const theme = isDarkTheme() ? 'dark' : 'light';

  return (
    <Card>
      <CardHeader icon={LuChartColumn} title="Statistiques d'usage" subtitle="Fréquentation de Globe Weekly, fournie par Plausible" />
      <div className="relative overflow-hidden rounded-b-xl">
        {isLoading && (
          <div className="absolute inset-0 flex items-start justify-center bg-white pt-24 dark:bg-night-800">
            <SpinnerRing size="lg" label="Chargement des statistiques" />
          </div>
        )}
        <iframe
          plausible-embed="true"
          src={`https://plausible.io/share/weekly.globe-groupe.com?auth=Uba1mZUzqgHu2iiU4jSkK&embed=true&theme=${theme}`}
          scrolling="no"
          frameBorder="0"
          loading="lazy"
          className="h-[2200px] w-full"
          title="Plausible Analytics"
          onLoad={() => setIsLoading(false)}
        />
        {/* Plausible's resizer: React 19 loads async scripts rendered in the tree. */}
        <script async src="https://plausible.io/js/embed.host.js" />
      </div>
    </Card>
  );
};

export default PlausibleData;
